import React, { useState, useEffect } from 'react';
import AppAnon from './AppAnon';
import AppLogged from './AppLogged';
import axios from 'axios';
import { initTealium, tealiumTrack } from './utils/tealium';



export default function App(props) {
	// since this isn't going to change, we can set as a constant right at the top. 
	const isStandalone = window.self === window.top


	const queryParams = new URLSearchParams(window.location.search);
	const oktaAppFlag = queryParams.get('okta');


	const [loggedIn, setLoggedIn] = useState(false);

		// Internet Explorer 6-11
		const isIE = /*@cc_on!@*/false || !!document.documentMode;

	useEffect(() => {
		initTealium().then(() => {
			tealiumTrack('App loaded','view')
		})
	},[])

	// used to check to see if we are logged in or not and setup token

	useEffect(() => {

			axios.get('/auth/current-session', { withCredentials: true }).then(({ data }) => {
				setLoggedIn(isStandalone && data);
			});
		
	}, []);


	const fncSetLoggin = () => {


	
		tealiumTrack('bond-pyramid:button-selected:get-started','link')


		let authURL = '/auth/login?appID=bp';

		if (oktaAppFlag == 1) {
				authURL = '/auth/login?appID=bp&okta=1';
		}


	   if (isIE) {
			const newWindowIEH = window.open(authURL, '_blank', 'width=1200,height=800,scrollbars=1,location=no,menubar=no,toolbar=no,resizable=yes,status=yes').focus();
	   } else {
			const newWindowH = window.open(authURL, '_blank', 'noopener,noreferrer');
	   }
	


	}



	return (
		<>
			{!loggedIn && 
				<AppAnon 
					setLoggedIn = {() => fncSetLoggin()}
				/>
			}
			{loggedIn && 
				<AppLogged />
			}
		</>
	);
}
